<template>
  <v-app>
    <div class="row">
      <div class="col-12">
        <div class="card ">
          <div class="card-header">
            <div class="card-title pt-3 px-3 d-flex justify-content-between">
              <div class="breadcrumb-left">
                <h4>Shelves</h4>
                <div class="breadcrumb-sub-header">
                  <router-link to="/dashboard">Dashboard</router-link>
                  \ Shelves
                </div>
              </div>
              <div class="breadcrumb-right"  v-if="checkIsAccessible('library-shelf', 'create')">
                <div class="card-toolbar">
                  <v-btn @click="openCreateForm()" class="mt-4 btn btn-primary" style="color: #fff">
                    <v-icon small elevation="2" outlined>fas fa-plus</v-icon>&nbsp;
                    Add new
                  </v-btn>
                </div>
              </div>
            </div>
          </div>
          <div class="card-body">
            <div class="table-responsive ">
              <table class="table">
                <thead>
                <tr class="px-3">
                  <th>Shelve name</th>
                  <th>Total racks</th>
                  <th class="px-3">Status</th>
                  <th class="pr-3 text-center">Action</th>
                </tr>
                </thead>
                <tbody>
                <tr v-show="shelves.length > 0" v-for="(self, index)  of shelves" :key="index">
                  <td>
                    <span class="font-weight-black">
                      {{ self.title }}
                    </span>
                  </td>
                  <td>
                    <span class="font-weight-medium">
                      {{ self.total_racks || '0' }}
                    </span>
                  </td>
                  <td class="px-3" style="max-width: 270px !important; white-space: pre-wrap;">
                          <span class="badge badge-success text-lg`"
                                v-bind:class="{ 'badge-success': self.is_active, 'badge-danger': !self.is_active }"
                          >{{ self.is_active ? 'Active' : 'Inactive' }}</span>
                  </td>
                  <td class="pr-0 text-center">
                    <b-dropdown
                        size="sm"
                        variant="link"
                        toggle-class="custom-v-dropdown btn btn-clean btn-hover-light-primary btn-sm btn-icon"
                        no-caret
                        right
                        no-flip
                    >
                      <template v-slot:button-content>
                        <slot>
                              <span>
                                <i class="flaticon-more-1"></i>
                              </span>
                        </slot>
                      </template>
                      <!--begin::Navigation-->
                      <div class="navi navi-hover ">
                        <b-dropdown-text tag="div" class="navi-item">
                          <a href="#" class="navi-link"
                             @click="manageShelf(self.id)">
                                                                <span class="navi-icon">
                                                                  <i class="fas fa-cog"></i>
                                                                </span>
                            <span class="navi-text">  Manage racks</span>
                          </a>
                        </b-dropdown-text>
                        <b-dropdown-text tag="div" class="navi-item" v-if="checkIsAccessible('library-shelf', 'edit')">
                          <a href="#" class="navi-link"
                             @click="editShelf(self)">
                                                                <span class="navi-icon">
                                                                  <i class="flaticon-edit"></i>
                                                                </span>
                            <span class="navi-text">  Edit</span>
                          </a>
                        </b-dropdown-text>
                        <b-dropdown-text tag="div" class="navi-item" v-if="checkIsAccessible('library-shelf', 'delete')">
                          <a href="#" class="navi-link"
                             @click="deleteShelf(self.id)">
                                                                <span class="navi-icon">
                                                                  <i class="fas fa-trash"></i>
                                                                </span>
                            <span class="navi-text">  Delete</span>
                          </a>
                        </b-dropdown-text>

                      </div>
                      <!--end::Navigation-->
                    </b-dropdown>
                  </td>
                </tr>
                <tr v-if="shelves.length == 0">
                  <td  class="px-3 text-center" colspan="3">
                    <strong>Items not found.</strong>
                  </td>
                </tr>
                </tbody>

              </table>
              <b-pagination
                  v-if="shelves.length > 0"
                  class="pull-right mt-7"
                  @input="getShelves"
                  v-model="page"
                  :total-rows="total"
                  :per-page="perPage"
                  first-number
                  last-number
                  :disabled="loading"
              ></b-pagination>
            </div>
          </div>
        </div>
        <create-and-update ref="shelf" :dialog="dialog" @close_dialog="getShelves"></create-and-update>
      </div>
    </div>
    <!--    <rack-create-and-update ref="rack" @close_dialog="closeRackDialog"></rack-create-and-update>-->
  </v-app>
</template>
<script>
import ShelfService from "@/core/services/library/shelf/ShelfService";
import CreateAndUpdate from "@/view/pages/library/shelf/CreateAndUpdate";
import RackCreateAndUpdate from "@/view/pages/library/shelf/rack/CreateAndUpdate";
import LibraryShelfRackService from "@/core/services/library/shelf/LibraryShelfRackService";

const rackService = new LibraryShelfRackService();
const shelf = new ShelfService();

export default {
  name: "Index",
  components: {CreateAndUpdate},
  data() {
    return {
      fields: [
        {key: 'title', label: 'Shelve name'},
        // {key: 'is_active', label: "Status"},
        {key: 'total_racks', label: "Total racks"},
        {key: 'action', label: "Action"},
        {key: 'rack_detail', label: "Rack"},
      ],
      shelves: [],
      shelf_id: null,
      dialog: false,
      total: null,
      perPage: null,
      page: null,
      loading:false,
    }
  },
  mounted() {
    this.getShelves()
  },
  methods: {
    getShelves() {
      this.dialog =false;
      this.loading=true;
        shelf
          .paginate()
          .then(response => {
              this.shelves = response.data.data;
              this.page = response.data.meta.current_page;
              this.total = response.data.meta.total;
              this.perPage = response.data.meta.per_page;
          })
            .catch((err) => {
            this.loading = false;
           })
            .finally(()=>{
            this.loading = false;
          });

    },
    openCreateForm() {
      this.dialog = true
    },

    editShelf(shelf) {
      this.dialog = true
      this.$refs['shelf'].setValue(shelf);
    },
    deleteShelf(id) {
      this.$confirm({
        message: `Are you sure?`,
        button: {
          no: "No",
          yes: "Yes"
        },
        callback: confirm => {
          if (confirm) {
            shelf.delete(id).then(response => {
              this.getShelves();
            })
          }
        }
      });
    },
    deleteRack(shelfId, id) {
      this.$confirm({
        message: `Are you sure?`,
        button: {
          no: "No",
          yes: "Yes"
        },
        callback: confirm => {
          if (confirm) {
            shelf.delete(shelfId, id).then(response => {
              this.$snotify.success("Shelf deleted successfully")
              this.getShelves();
            })
          }
        }
      });
    }, manageShelf(id) {
      this.$router.push({name: 'shelf-rack', params: {id: id}})
    }
  }
}
</script>

<style scoped>
</style>
